import { action, makeObservable, observable } from 'mobx'

import { IRootStore } from 'store/types'
import { USER_PERMISSION } from 'shared/types/types'

import { PersonalDataStep } from '../../types'
import { CompanyDetailsViewModel } from '../models/CompanyDetailsViewModel'
import { ProfileViewModel } from '../models/ProfileViewModel'
import { ValidatePersonalDataStore } from '../ValidatePersonalDataStore'
import { RegistrationApiStore } from './RegistrationApiStore'

export class RegistrationUiStore {
  @observable readonly profile: ProfileViewModel = new ProfileViewModel()
  @observable readonly companyDetails: CompanyDetailsViewModel = new CompanyDetailsViewModel()
  @observable readonly apiStore = new RegistrationApiStore(this)
  @observable readonly validateStore = new ValidatePersonalDataStore(this.profile, this.companyDetails)

  @observable userRole: USER_PERMISSION = USER_PERMISSION.PERM_OWNER

  @observable personalDataStep: PersonalDataStep = PersonalDataStep.step1

  @observable isRegistrationLoading: boolean = false

  constructor(readonly rootStore: IRootStore) {
    makeObservable(this)
  }

  @action
  setUserRole = (value: USER_PERMISSION) => {
    this.userRole = value
  }

  @action
  setPersonalDataStep = (value: PersonalDataStep) => {
    this.personalDataStep = value
  }

  @action
  setRegistrationLoading = (value: boolean) => {
    this.isRegistrationLoading = value
  }
}
